<ng-container *ngIf="(message$ | async) as message">
  <div class="alert {{message.alertClass}} alert-dismissible fade show" role="alert">
    <div class="mb-3">
      <h4 class="me-auto"><i class="{{message.iconClass}}" aria-hidden="true"></i> {{message.headerText}}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div>{{message.messageText}}</div>
  </div>
</ng-container>
